import ApplicationState from "@insite/client-framework/Store/ApplicationState";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import React, { FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import loadWishLists from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";
import { OptionObject } from "@insite/mobius/DynamicDropdown";
import translate from "@insite/client-framework/Translate";
import { getWishListsDataView } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import debounce from "lodash/debounce";
import updateGetWishListsParameter from "@insite/client-framework/Store/Components/AddToListModal/Handlers/UpdateGetWishListsParameter";
import setAddToListModalIsOpen from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
// import addToWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import { Button, Modal, TextField, Typography } from "@insite/mobius/index";
import { TypographyProps } from "@insite/mobius/Typography";
import CrossIcon from "@NA/Icons/CrossIcon";
import { ModalProps } from "@insite/mobius/Modal";
import { TextFieldProps } from "@insite/mobius/TextField";
import { ButtonProps } from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import { getProp } from "@insite/mobius/utilities";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import ADIColors from "@NA/Utils/ADIColors";
import saveWishListLine from "@NA/Handlers/ADISaveWishListLineHandler";
import { spaceValidation } from "@NA/Utils/Utility";
import addToWishList from "@NA/Handlers/AddToWishList";

interface OwnProps {
    isOpen?: boolean;
    productInfos: ProductInfo;
    setIsOpen?: (item: boolean) => void;
}

export interface CustomAddToListStyles {
    container?: InjectableCss;
    listsContainer?: InjectableCss;
    listItem?: InjectableCss;
    plusIcon?: TypographyProps;
    addedToListPopup?: ModalProps;
    newListPopup?: ModalProps;
    textField?: TextFieldProps;
    cancelBtn?: ButtonProps;
    createListBtn?: ButtonProps;
    actionBtnContainer?: InjectableCss;
    errorMsg?: TypographyProps;
}

export const CustomAddToListStyles: CustomAddToListStyles = {
    container: {
        css: css`
            box-shadow: 1px 2px 14px 4px rgba(57, 57, 58, 0.25);
            position: absolute;
            background: ${ADIColors.white};
            min-width: 220px;
            left: -91px;
            top: 28px;
            z-index: 10;
            :after {
                width: 0;
                height: 0;
                border-left: 25px solid transparent;
                border-right: 25px solid transparent;
                border-bottom: 20px solid ${ADIColors.white};
                margin-top: -8px;
                margin-left: 5px;
                position: absolute;
                z-index: 9;
                content: " ";
                right: 0;
                top: 0;
            }

            .new-list {
                :hover {
                    background-color: ${ADIColors.white};
                    color: ${ADIColors.black};
                }
            }
        `,
    },
    listItem: {
        css: css`
            padding: 10px 0 5px 13px;
            cursor: pointer;
            border-bottom: 1px solid ${getColor("text.disabled")};
            color: ${ADIColors.black};
            margin-left: 0;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            line-height: 18px;
            font-weight: 600;
            min-height: 42px;
            display: flex;
            align-items: center;
            transition: 0.2s ease all;
            :hover {
                background-color: ${getColor("secondary")};
                color: ${ADIColors.white};
            }
        `,
    },
    listsContainer: {
        css: css`
            max-height: 205px;
            overflow-y: auto;
        `,
    },
    plusIcon: {
        css: css`
            padding-right: 10px;
            color: ${getColor("primary")};
            font-size: 25px;
            display: block;
            font-weight: 600;
            margin-top: -4px;
        `,
    },
    addedToListPopup: {
        sizeVariant: "small",
        size: 600,
        closeButtonIconProps: {
            src: CrossIcon,
            size: 20,
        },
        cssOverrides: {
            modalContainer: css`
                > div {
                    box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.14);
                    border-radius: 7px;
                }
                button svg {
                    transform: translate(-10px, -6px);
                }
            `,
            modalTitle: css`
                border-bottom: 0;
                span {
                    font-size: 28px;
                    font-weight: bold;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: ${ADIColors.darkBlue1};
                    width: calc(100% - 35px);
                    display: inline-block;
                    text-transform: capitalize;
                }
                button {
                    position: absolute;
                    top: 14px;
                    right: 32px;
                }
            `,
            modalContent: css`
                padding: 0 30px 30px;
            `,
        },
    },
    newListPopup: {
        sizeVariant: "small",
        closeButtonIconProps: {
            src: CrossIcon,
            size: 20,
        },
        cssOverrides: {
            modalContainer: css`
                > div {
                    box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.14);
                    border-radius: 7px;
                }
                button svg {
                    transform: translate(-10px, -6px);
                }
            `,
            modalTitle: css`
                border-bottom: 0;
                span {
                    font-size: 28px;
                    font-weight: bold;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: ${ADIColors.darkBlue1};
                    width: calc(100% - 35px);
                    display: inline-block;
                    text-transform: capitalize;
                }
                button {
                    position: absolute;
                    top: 14px;
                    right: 32px;
                }
            `,
            modalContent: css`
                padding: 0 30px 30px;
            `,
        },
    },
    textField: {
        css: css`
            margin-bottom: 20px;
            [class^="FormInputWrapper-"] {
                margin-bottom: 15px;
            }
        `,
        labelProps: {
            size: 14,
            weight: "bold",
            css: css`
                color: ${getColor("text.main")};
                min-height: auto;
            `,
        },
    },
    actionBtnContainer: {
        css: css`
            display: flex;
            justify-content: flex-end;
            z-index: 9999;
            background-color: ${ADIColors.white};
        `,
    },
    cancelBtn: {
        css: css`
            border: solid 1px ${getColor("secondary")};
            margin-right: 20px;
            border-radius: 4px;
            text-transform: uppercase;
            background: ${ADIColors.white};
            min-height: 40px;
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: bold;
            span {
                color: ${getColor("secondary")} !important;
            }
            &:hover {
                background: ${ADIColors.secondaryButtonHoverLightBlue};
            }  
        `,
    },
    createListBtn: {
        css: css`
            border: solid 1px ${ADIColors.blue5};
            border-radius: 4px;
            text-transform: uppercase;
            background: ${ADIColors.blue5};
            min-height: 40px;
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: bold;
            span {
                color: ${ADIColors.white} !important;
            }
            &:hover {
                background: ${getColor("secondary")};
            }
        `,
    },
    errorMsg: {
        css: css`
            color: ${ADIColors.danger} !important;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            margin-bottom: 5px;
            font-weight: 600;
        `,
    },
};

const mapStateToProps = (state: ApplicationState) => {
    const getWishListsParameterCustom = state.components.addToListModal.getWishListsParameter;
    return {
        getWishListsParameter: state.components.addToListModal.getWishListsParameter,
        wishListsDataView: getWishListsDataView(state, state.components.addToListModal.getWishListsParameter),
        getWishListsParameterCustom,
    };
};

const mapDispatchToProps = {
    loadWishLists,
    updateGetWishListsParameter,
    setAddToListModalIsOpen,
    addToWishList,
    saveWishListLine,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const styles = CustomAddToListStyles;

const CustomAddToList: FC<Props> = ({
    isOpen,
    loadWishLists,
    getWishListsParameter,
    wishListsDataView,
    updateGetWishListsParameter,
    productInfos,
    addToWishList,
    setIsOpen,
    saveWishListLine,
}) => {
    const [selectedWishListId, setSelectedWishListId] = useState("new");
    const [selectListError, setSelectListError] = useState<React.ReactNode>("");
    const [newListName, setNewListName] = useState("");
    const [options, setOptions] = useState<OptionObject[]>([]);
    const toasterContext = useContext(ToasterContext);
    const [productAddtoList, setproductAddtoList] = React.useState(false);
    const [openNewListPopup, setOpenNewListPopup] = React.useState(false);
    const [selectedWhishlist, setSelectedWhishlist] = React.useState<WishListModel>();
    const [newListNameError, setNewListNameError] = useState<React.ReactNode>("");
    const [newListAdded, setNewListAdded] = useState(false);
    const addToListContainerRef = React.useRef<HTMLDivElement>(null);
    const modalRef = React.useRef<HTMLDivElement>(null);

    const handleOutsideClick = (event: MouseEvent) => {
        event.stopPropagation();
        if ((modalRef.current && modalRef.current.contains(event.target as Node)) ||
            (addToListContainerRef.current && addToListContainerRef.current.contains(event.target as Node))) {
            if (!isOpen) setIsOpen?.(true);
            return;
        }
        if ((event?.target instanceof Element) &&
            event.target.parentElement?.id === ""
        ) {
            setIsOpen?.(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const closePopup = () => {
        if (productAddtoList) setproductAddtoList(false);

        if (openNewListPopup) setOpenNewListPopup(false);

        setIsOpen?.(false);
        setNewListName("");
        setNewListNameError("");
    };

    useEffect(() => {
        setproductAddtoList(false);

    }, []);

    useEffect(() => {
        if (isOpen) {
            loadWishLists(getWishListsParameter);
            setNewListAdded(false);
            setOpenNewListPopup(false);
            setNewListName("");
            setproductAddtoList(false);
        }
    }, [isOpen]);

    useEffect(() => {
        if (wishListsDataView.value) {
            let options: OptionObject[] = [];
            options = options.concat(wishListsDataView.value.map(o => ({ optionText: o.name, optionValue: o.id })));
            setOptions(options);
        }
    }, [wishListsDataView]);

    const debouncedUpdateParameter = debounce((value: string) => {
        updateGetWishListsParameter({
            ...getWishListsParameter,
            query: value || undefined,
        });
    }, 200);

    const newListInputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValues = spaceValidation(event.target.value);
        setNewListName(inputValues);
        if (event.target.value) {
            setNewListNameError("");
        }
    };

    const listsInputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        debouncedUpdateParameter(event.currentTarget.value);
    };

    const listChangeHandler = (value?: string) => {
        setSelectedWishListId(value || "new");
        setSelectListError("");
    };

    const addToWishListHander = (whislistId: string) => {
        setNewListNameError("");
        if (!whislistId) {
            return;
        }

        const isNewList = whislistId === "new";
        if (isNewList && !newListName) {
            setNewListNameError(siteMessage("Lists_Enter_New_Wishlist_Name"));
            return;
        }
        const selectedWhishlist = wishListsDataView.value?.find(o => o.id === whislistId);
        setSelectedWhishlist(selectedWhishlist);
        setSelectedWishListId(whislistId);
        sessionStorage.setItem("item_list_name", "Recently Purchased");
        if (!isNewList) {
            saveWishListLine({
                wishListId: whislistId,
                productId: productInfos.productId,
                qtyOrdered: 1,
                unitOfMeasure: productInfos.unitOfMeasure,
                properties: { name: selectedWhishlist?.name },
                productInfo: productInfos,
                onSuccess() {
                    setproductAddtoList(true);
                },
            });
        } else {
            addToWishList({
                productInfos: [productInfos],
                selectedWishList: isNewList ? undefined : wishListsDataView.value?.find(o => o.id === whislistId),
                newListName,
                onSuccess: (wishList: WishListModel) => {
                    if (isNewList) {
                        setNewListAdded(true);
                    } else {
                        setproductAddtoList(true);
                    }
                },
                onError: errorMessage => {
                    if (isNewList) {
                        setNewListNameError(errorMessage);
                    } else {
                        toasterContext.addToast({ body: errorMessage, messageType: "danger" });
                    }
                },
                onComplete(wishListProps) {
                    setIsOpen?.(false);
                    if (wishListProps?.result?.wishList) {
                        // "this" is targeting the object being created, not the parent SFC
                        // eslint-disable-next-line react/no-this-in-sfc
                        this.onSuccess?.(wishListProps?.result?.wishList);
                    } else if (wishListProps?.result?.errorMessage) {
                        // "this" is targeting the object being created, not the parent SFC
                        // eslint-disable-next-line react/no-this-in-sfc
                        this.onError?.(wishListProps?.result?.errorMessage);
                    }
                },
            });
        }
    };

    const createNewListHandler = () => {
        addToWishListHander("new");
    };

    const modalStyleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        if (modalRef.current && modalRef.current.contains(event.target as Node)) {
            setIsOpen?.(false);
            return;
        }

        setIsOpen?.(true);
    };

    return (
        <>
            {isOpen && !productAddtoList && !openNewListPopup ? (
                <StyledWrapper {...styles.container} ref={addToListContainerRef}>
                    <StyledWrapper {...styles.listItem} onClick={() => setOpenNewListPopup(true)} className="new-list">
                        <Typography {...styles.plusIcon}>+</Typography>
                        {translate("Create New List")}
                    </StyledWrapper>
                    <StyledWrapper {...styles.listsContainer}>
                        {options.map(option => {
                            return (
                                <StyledWrapper
                                    onClick={() => addToWishListHander(option.optionValue || "")}
                                    {...styles.listItem}
                                    key={option.optionValue}
                                >
                                    {option.optionText}
                                </StyledWrapper>
                            );
                        })}
                    </StyledWrapper>
                </StyledWrapper>
            ) : null}
            <Modal
                headline={<Typography>{translate("Added to List")}</Typography>}
                {...styles.addedToListPopup}
                isOpen={productAddtoList}
                handleClose={closePopup}
            >
                <StyledWrapper
                    ref={modalRef}
                    onClick={(event: React.MouseEvent<HTMLElement>) => modalStyleClick(event)}
                >
                    {selectedWhishlist?.name ? (
                        <Typography>
                            {translate(`You successfully added this item to {0}`, selectedWhishlist.name)}
                        </Typography>
                    ) : null}
                </StyledWrapper>
            </Modal>
            <Modal
                headline={
                    newListAdded ? (
                        <Typography onClick={(event: React.MouseEvent<HTMLElement>) => modalStyleClick(event)}>
                            {translate("List Created")}
                        </Typography>
                    ) : (
                        <Typography onClick={(event: React.MouseEvent<HTMLElement>) => modalStyleClick(event)}>
                            {translate("Create New List")}
                        </Typography>
                    )
                }
                {...styles.newListPopup}
                isOpen={openNewListPopup}
                handleClose={closePopup}
                size={newListAdded ? 600 : 400}
            >
                <StyledWrapper
                    ref={modalRef}
                    onClick={(event: React.MouseEvent<HTMLElement>) => modalStyleClick(event)}
                >
                    {newListAdded ? (
                        <StyledWrapper>
                            <Typography>
                                {translate("You have successfully created a new list and added this item")}
                            </Typography>
                        </StyledWrapper>
                    ) : (
                        <StyledWrapper>
                            {newListNameError && (
                                <Typography {...styles.errorMsg} as="p">
                                    {newListNameError}
                                </Typography>
                            )}
                            <StyledWrapper>
                                <TextField
                                    label={translate("Create a new list")}
                                    value={newListName}
                                    onChange={newListInputChangeHandler}
                                    {...styles.textField}
                                    data-test-selector="productAddToListModal_newName"
                                    placeholder={translate("List Name")}
                                    maxLength={12}
                                />
                            </StyledWrapper>
                            <StyledWrapper {...styles.actionBtnContainer}>
                                <Button onClick={closePopup} {...styles.cancelBtn}>
                                    {translate("Cancel")}
                                </Button>
                                <Button onClick={createNewListHandler} {...styles.createListBtn}>
                                    {translate("Create")}
                                </Button>
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            </Modal>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomAddToList);
